import Vue from "vue";
import VueRouter from "vue-router";

import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
NProgress.configure({ showSpinner: false }); // NProgress configuration

import { afterEach } from "./afterEach";
import { beforeEach } from "./beforeEach";

import Layout from "@/components/Layout";
// import { component } from "vue/types/umd";
Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login"),
    hidden: true,
  },
  {
    path: "/",
    component: Layout,
    children: [
      {
        path: "/",
        name: "index",
        component: () => import("@/views/index"),
        hidden: true,
      },

      {
        path: "/system/user",
        name: "system-user",
        meta: { title: "用户管理" },
        component: () => import("@/views/system/user"),
      },
      {
        path: "/system/user/add",
        name: "system-user-add",
        meta: { title: "用户管理-添加" },
        component: () => import("@/views/system/user/edit"),
      },
      {
        path: "/system/user/edit/:id",
        name: "system-user-edit",
        meta: { title: "用户管理-编辑" },
        component: () => import("@/views/system/user/edit"),
      },
      {
        path: "/system/user/changePwd/:id",
        name: "system-user-changePwd",
        meta: { title: "用户管理-修改密码" },
        component: () => import("@/views/system/user/changePwd"),
      },
      {
        path: "/system/loginLog",
        name: "loginLog_list",
        meta: { title: "登录日志管理" },
        component: () => import("@/views/system/loginLog/index"),
      },
      {
        path: "/system/org",
        name: "system-org",
        meta: { title: "机构管理" },
        component: () => import("@/views/system/org"),
      },
      {
        path: "/system/orgUser",
        name: "system-orgUser",
        meta: { title: "机构用户管理" },
        component: () => import("@/views/system/orgUser/index"),
      },
      {
        path: "/system/right",
        name: "system-right",
        meta: { title: "菜单权限管理", icon: "table" },
        component: () => import("@/views/system/right/index"),
      },
      {
        path: "/system/role",
        name: "system-role",
        meta: { title: "角色管理", icon: "table" },
        component: () => import("@/views/system/role/index"),
      },
      {
        path: "/system/dict",
        name: "system-dict",
        meta: { title: "字典管理", icon: "table" },
        component: () => import("@/views/system/dict/dict"),
      },
      {
        path: '/sys/sysman',
        name: 'SysSysman',
        component: () => import('@/views/sysman/config'),
        meta: { title: '配置项管理', icon: 'table' }
      },
      {
        path: "401",
        name: "401",
        meta: { title: "没有权限" },
        component: () => import("@/views/error/401"),
        hidden: true,
      },
      //{ path: '*', name: '404', meta: { title: "页面未找到" }, component: () => import('@/views/error/404'), hidden: true  },
    ],
  },
  {
    path: "/sysman",
    component: Layout,
    redirect: "/sysman/config",
    name: "setting",
    meta: { title: "配置项管理", icon: "example" },
    children: [
      {
        path: "/sysman/config",
        name: "setting_list",
        component: () => import("@/views/sysman/config"),
        meta: { title: "配置项管理", icon: "table" },
      },
      {
        path: "/sysman/config/addGroup",
        name: "setting_group_add",
        component: () => import("@/views/sysman/editGroup"),
        meta: { title: "配置项-添加分组", icon: "table" },
      },
      {
        path: "/sysman/config/editGroup/:id",
        name: "setting_group_edit",
        meta: { title: "配置项-编辑分组" },
        component: () => import("@/views/sysman/editGroup"),
      },
      {
        path: "/sysman/config/addSetting/:parentId",
        name: "setting_add",
        component: () => import("@/views/sysman/editSetting"),
        meta: { title: "配置项-添加配置项", icon: "table" },
      },
      {
        path: "/sysman/config/editSetting/:id",
        name: "setting_edit",
        component: () => import("@/views/sysman/editSetting"),
        meta: { title: "配置项-编辑配置项", icon: "table" },
      },
    ],
  },
  //参赛人管理模块
  {
    path: "/liaison",
    component: Layout,
    redirect: "/liaison/index",
    name: "liaison",
    meta: { title: "参赛人管理", icon: "exmaple" },
    children: [
      {
        path: "/liaison/index",
        name: "LiaisonIndex",
        component: () => import("@/views/liaison/index"),
        meta: { title: "参赛人管理", icon: "user" },
      },
      {
        path: "/manage/member",
        name: "ManageMember",
        component: () => import("@/views/manage/member"),
        meta: { title: "管理员管理", icon: "user" },
      },
    ],
  },
  //赛事模块
  {
    path: "/contest",
    component: Layout,
    redirect: "/contest/index",
    name: "Contest",
    meta: { title: "赛事信息管理", icon: "exmaple" },
    children: [
      {
        path: "/contest/index",
        name: "ContestIndex",
        component: () => import("@/views/contest/contest/index"),
        meta: { title: "赛事管理", icon: "exmaple" },
      },
      {
        path: "/contest/item",
        name: "ContestItem",
        component: () => import("@/views/contest/item/index"),
        meta: { title: "赛事项目管理", icon: "exmaple" },
      },
      {
        path: "/contest/score",
        name: "ContestScore",
        component: () => import("@/views/contest/score/index"),
        meta: { title: "赛事积分管理", icon: "exmaple" },
      },
      {
        path: "/contest/score-import",
        name: "ContestScoreImport",
        component: () => import("@/views/contest/scoreImport/index"),
        meta: { title: "积分导入管理", icon: "exmaple" },
      },
    ],
  },
  //赛事预约报名管理
  {
    path: "/enroll",
    component: Layout,
    redirect: "/enroll/index",
    name: "Enroll",
    meta: { title: "赛事预约管理", icon: "exmaple" },
    children: [
      {
        path: "/enroll/index",
        name: "EnrollIndex",
        component: () => import("@/views/enroll/index"),
        meta: { title: "预约报名管理", icon: "exmaple" },
      },
    ],
  },
  //商户管理
  {
    path: "/business",
    component: Layout,
    redirect: "/business/index",
    name: "Business",
    meta: { title: "商户管理", icon: "exmaple" },
    children: [
      {
        path: "/business/index",
        name: "BusinessIndex",
        component: () => import("@/views/business/index"),
        meta: { title: "商户管理", icon: "exmaple" },
      },
    ],
  },
  //用户模块
  {
    path: "/user",
    component: Layout,
    redirect: "/user/index",
    name: "user",
    meta: { title: "用户积分管理", icon: "exmaple" },
    children: [
      {
        path: "/user/score",
        name: "userScore",
        component: () => import("@/views/user/score/index"),
        meta: { title: "用户积分管理", icon: "exmaple" },
      },
      {
        path: "/user/history",
        name: "historyIndex",
        component: () => import("@/views/user/history/index"),
        meta: { title: "导入积分历史", icon: "exmaple" },
      },
      {
        path: "/user/score-history",
        name: "userScoreHistory",
        component: () => import("@/views/user/scoreHistory/index"),
        meta: { title: "用户积分历史", icon: "exmaple" },
      },
    ],
  },
  //发票模块
  {
    path: "/invoice",
    component: Layout,
    redirect: "/invoice/index",
    name: "invoice",
    meta: { title: "发票管理", icon: "exmaple" },
    children: [
      {
        path: "/invoice/index",
        name: "invoiceIndex",
        component: () => import("@/views/invoice/index"),
        meta: { title: "开票管理", icon: "exmaple" },
      },
      {
        path: "/invoice/invoiceSwitch",
        name: "invoiceSwitch",
        component: () => import("@/views/invoice/invoiceSwitch"),
        meta: { title: "开票启停", icon: "exmaple" },
      },
    ]
  },
  {
    path: "/wantInvoice",
    name: "wantInvoice",
    component: () => import("@/views/invoice/conformInvoice"),
    hidden: true,
  },
  {
    path: "/wantEnrolls",
    name: "wantEnrolls",
    component: () => import("@/views/enroll/myEnrolls"),
    hidden: true,
  },
  {
    path: "/wantScores",
    name: "wantScores",
    component: () => import("@/views/score/publicScoreQuery"),
    hidden: true,
  },



];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  NProgress.start();
  //前置拦截器
  beforeEach(to, from).then((path) => {
    next(path);
  });
});

router.afterEach((to, from) => {
  // ...
  //拦截器
  afterEach(to, from);

  NProgress.done();
});
export default router;
